import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { FC, useState } from 'react';
import SortBottomSheet from './SortBottomSheet';
import { IconAlign16, IconCheckCircle16, IconCheckCircleEmpty16 } from 'components/base/Icon';
import Text from 'components/base/Text';
import { useSearchQueryString } from 'hooks';
import { blue150, blue400, blue600, gray_tertiary, white } from 'styles';
import { DEFAULT_SORT_TYPE, SORT_TYPE, SORT_TYPE_LIST } from 'util/search_utils';
import { Log } from 'util/Tracker';

interface Props {
  search_ubl: Omit<Log, 'category'>;
  is_show_sort_filter?: boolean;
}
/**
 * 검색필터 - 필터Sheet가 아닌 클릭시 바로 검색이 되는 검색 영역
 * @component
 */
const DirectSearchInfo: FC<Props> = ({ search_ubl, is_show_sort_filter }) => {
  const [is_open_sort_sheet, setIsOpenSortSheet] = useState(false);
  const router = useRouter();
  const { search_props, sort_type, is_selected_sort_type } = useSearchQueryString();

  const handleZiginShippingClick = () => {
    router.replace({
      pathname: router.pathname,
      query: {
        ...router.query,
        is_zigin_shipping: search_props.is_zigin_shipping ? !search_props.is_zigin_shipping : true,
      },
    });
  };

  const handleFastShippingClick = () => {
    router.replace({
      pathname: router.pathname,
      query: {
        ...router.query,
        is_fast_shipping: search_props.is_fast_shipping ? !search_props.is_fast_shipping : true,
      },
    });
  };

  return (
    <>
      <SC.Container>
        <SC.DirectFilter>
          <button className='shipping' onClick={handleZiginShippingClick}>
            {search_props.is_zigin_shipping ? (
              <IconCheckCircle16 color={blue600} />
            ) : (
              <IconCheckCircleEmpty16 color={blue150} />
            )}
            <Text variant='body4_medium' color='blue600'>
              직진배송
            </Text>
          </button>
          <button className='shipping' onClick={handleFastShippingClick}>
            {search_props.is_fast_shipping ? (
              <IconCheckCircle16 color={blue400} />
            ) : (
              <IconCheckCircleEmpty16 color={blue150} />
            )}
            <Text variant='body4_medium' color='blue400'>
              빠른출발
            </Text>
          </button>
        </SC.DirectFilter>
        {is_show_sort_filter && (
          <button onClick={() => setIsOpenSortSheet(true)}>
            <Text variant='body4_medium' color='gray_secondary'>
              {getSortFilterName(sort_type, is_selected_sort_type)}
            </Text>
            <IconAlign16 className='sort' color={gray_tertiary} />
          </button>
        )}
      </SC.Container>
      <SortBottomSheet
        open_sort_sheet={is_open_sort_sheet}
        active_sort_type={sort_type}
        search_ubl={search_ubl}
        onToggleSheet={setIsOpenSortSheet}
      />
    </>
  );
};

export default DirectSearchInfo;

function getSortFilterName(sort_type: SORT_TYPE, is_selected_sort_type: boolean) {
  if (!is_selected_sort_type) {
    return SORT_TYPE_LIST.find((item) => item.type === DEFAULT_SORT_TYPE)?.text;
  }
  return SORT_TYPE_LIST.find((sort) => sort.type === (sort_type as SORT_TYPE))?.text ?? '';
}

const SC = {
  Container: styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0 16px 4px;
    height: 34px;

    button {
      cursor: pointer;
      display: flex;
      align-items: center;

      &:active {
        background-color: ${white};
      }
    }

    .sort {
      margin-left: 4px;
    }

    .shipping {
      margin-right: 8px;
      svg {
        margin-right: 3px;
      }
    }
  `,
  DirectFilter: styled.div`
    display: flex;
  `,
};
